// extracted by mini-css-extract-plugin
export default {"list":"styles_list__r6uRS","link":"styles_link__Zxu76"};